import { api } from "@/lib/api";

let contentPromise = null;

export function fetchCourse() {
  contentPromise = contentPromise || api.get("/course/content").then((r) => r.data).catch((e) => {
    contentPromise = null;
    throw e;
  });
  return contentPromise;
}

export const resetCourseCache = () => {
  contentPromise = null;
};

export function dayFields(day, worksheet) {
  return [
    ...day.class_questions.map((q) => ({ ...q, group: "Class questions", section: "class" })),
    { id: "host_question", prompt: "Question for the host", group: "Class questions", section: "class" },
    ...day.homework_questions.map((q) => ({ ...q, group: "Homework reflection", section: "homework" })),
    { id: "homework_evidence", prompt: "Homework evidence, sources, and links", group: "Homework reflection", section: "homework" },
    ...(worksheet ? worksheet.fields.map((q) => ({ ...q, group: `Worksheet ${worksheet.number}: ${worksheet.title}`, section: "worksheet" })) : []),
  ];
}
